import { ShopOutlined } from '@ant-design/icons';
import { lazyRouteComponent } from '@tanstack/react-router';

import { ACCOUNT_ROLE_CODES } from '@lib/types';
import { Route } from '@lib/types/route';

import { ROUTE_PATHS } from '../route-paths';

const StoreSettingsPage = lazyRouteComponent(() => import('./pages/settings'));
const AdminStoresPage = lazyRouteComponent(() => import('./pages/admin-list'));

export const getRoutes = (): Route[] => [
  {
    page: AdminStoresPage,
    path: ROUTE_PATHS.ADMIN_STORES,
    title: 'Lojas',
    icon: ShopOutlined,
    adminSection: 'operation',
    adminOrder: 20,
    acl: [ACCOUNT_ROLE_CODES.ADMIN],
  },
  {
    page: StoreSettingsPage,
    path: ROUTE_PATHS.SELLER,
    title: 'Configurar loja',
    icon: ShopOutlined,
  },
];
